import React from 'react';
import { FormInstance } from 'antd';
import DynamicQuestionnaire from '../forms/DynamicQuestionnaire';
import { QuestionnaireSchema } from '../forms/QuestionnaireSchema';
import { DEFAULT_HEALTH_SCHEMA } from '../forms/defaultHealthSchema';

// The health/PARQ questionnaire is now client-configurable. Callers pass the
// client's forms.health schema; when absent (or before any client_setting row
// exists) it falls back to DEFAULT_HEALTH_SCHEMA — the verbatim original PARQ —
// so behaviour is unchanged. The field keys stay identical to the original form,
// keeping health_form_answers storage backward-compatible.
const HealthForm: React.FC<{ form: FormInstance; schema?: QuestionnaireSchema }> = ({ form, schema }) => (
    <DynamicQuestionnaire schema={schema ?? DEFAULT_HEALTH_SCHEMA} form={form} />
);

export default HealthForm;
